"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGenerateDescriptionDto = instanceOfGenerateDescriptionDto;
exports.GenerateDescriptionDtoFromJSON = GenerateDescriptionDtoFromJSON;
exports.GenerateDescriptionDtoFromJSONTyped = GenerateDescriptionDtoFromJSONTyped;
exports.GenerateDescriptionDtoToJSON = GenerateDescriptionDtoToJSON;
exports.GenerateDescriptionDtoToJSONTyped = GenerateDescriptionDtoToJSONTyped;
/**
 * Check if a given object implements the GenerateDescriptionDto interface.
 */
function instanceOfGenerateDescriptionDto(value) {
    return true;
}
function GenerateDescriptionDtoFromJSON(json) {
    return GenerateDescriptionDtoFromJSONTyped(json, false);
}
function GenerateDescriptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'shiftInfo': json['shiftInfo'] == null ? undefined : json['shiftInfo'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'commitment': json['commitment'] == null ? undefined : json['commitment'],
        'housing': json['housing'] == null ? undefined : json['housing'],
        'meals': json['meals'] == null ? undefined : json['meals'],
        'scrubs': json['scrubs'] == null ? undefined : json['scrubs'],
        'differentials': json['differentials'] == null ? undefined : json['differentials'],
        'stipend': json['stipend'] == null ? undefined : json['stipend'],
        'arrivalInstructions': json['arrivalInstructions'] == null ? undefined : json['arrivalInstructions'],
        'emrSystem': json['emrSystem'] == null ? undefined : json['emrSystem'],
    };
}
function GenerateDescriptionDtoToJSON(json) {
    return GenerateDescriptionDtoToJSONTyped(json, false);
}
function GenerateDescriptionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'startDate': value['startDate'],
        'shiftInfo': value['shiftInfo'],
        'duration': value['duration'],
        'commitment': value['commitment'],
        'housing': value['housing'],
        'meals': value['meals'],
        'scrubs': value['scrubs'],
        'differentials': value['differentials'],
        'stipend': value['stipend'],
        'arrivalInstructions': value['arrivalInstructions'],
        'emrSystem': value['emrSystem'],
    };
}
//# sourceMappingURL=GenerateDescriptionDto.js.map